<script>
import ButtonText from "@/components/Global/ButtonText.vue";
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";

export default {
  name: "DeleteAllProductsModal",
  components: { ButtonPrimary, ButtonText },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    confirmDelete() {
      this.isLoading = true;
      this.$emit("deleteAllProducts");
    },
  },
};
</script>

<template>
  <div
    class="p-5 md:p-0 fixed w-full h-full flex justify-center items-center bg-overlay z-[55] top-0 left-0 bg-grays-900 bg-opacity-40"
  >
    <div
      class="bg-white w-full md:w-[660px] h-[360px] rounded overflow-hidden relative"
    >
      <div class="flex flex-col absolute left-0">
        <button
          class="mt-8 ml-8 w-9 h-9 rounded flex justify-center items-center"
          @click="closeModal"
        >
          <span class="material-symbols-rounded text-gray-700">close</span>
        </button>
      </div>
      <div class="w-full flex flex-col items-center justify-center h-full">
        <div class="text-error font-bold text-2xl items-center flex gap-2">
          <span class="text-error material-symbols-rounded text-xl">error</span>
          שימו לב!
        </div>
        <div
          class="text-grays-800 text-base mt-[35px] max-w-[450px] text-center p-5"
        >
          אתם עומדים למחוק את כל הפריטים שהוספתם לסל
          <br />
          האם אתם בטוחים שברצונכם להמשיך?
        </div>
        <div
          class="absolute bottom-0 w-full border-t border-grays-300 flex flex-row-reverse px-8 mb-4 gap-2 items-end"
        >
          <button-primary
            class="mt-6 self-end"
            :disabled="isLoading"
            @click="confirmDelete"
            :color="'error'"
          >
            <span
              v-if="isLoading"
              class="material-symbols-rounded animate-spin text-base"
              >progress_activity</span
            >
            <span v-else>אשרו</span>
          </button-primary>
          <button-text @click="$emit('closeModal')">בטלו</button-text>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>